// productReducer.js
import { createSelector } from 'reselect';
import { prop } from 'ramda';
import ProductAPI from '@/api/product-services/allProducts';
import ProductEnqAPI from '@/api/product-services/productEnquiry';
import { PRODUCT_ACTION as ACTIONS } from '../actions';

import { ProductEnquirePayloadProps } from '@/api/types';

const initialState = {
  products: [],
  error: null,
  loading: false,
  productEnquireStatus: '',
  productEnquireLoading: false,
};

const getSlice = prop('product');

export const getProducts = createSelector(getSlice, prop('products'));
export const getProductError = createSelector(getSlice, prop('error'));
export const isProductLoading = createSelector(getSlice, prop('loading'));
export const getProductEnquireStatus = createSelector(getSlice, prop('productEnquireStatus'));
export const productEnquireIsLoading = createSelector(getSlice, prop('productEnquireLoading'));

import { Dispatch } from 'redux';

export const fetchProducts = () => async (dispatch: Dispatch) => {
  dispatch({ type: ACTIONS.PRODUCT_REQUEST });
  try {
    const data = await ProductAPI();
    dispatch({
      type: ACTIONS.PRODUCT_SUCCESS,
      products: data,
    });
  } catch (error) {
    dispatch({
      type: ACTIONS.PRODUCT_FAILURE,
      error: error,
    });
  }
};

export const productEnquire = (payload: ProductEnquirePayloadProps) => async (dispatch: Dispatch) => {
  dispatch({ type: ACTIONS.PRODUCTENQ_REQUEST });
  try {
    const data = await ProductEnqAPI(payload);
    dispatch({
      type: ACTIONS.PRODUCTENQ_SUCCESS,
      productEnquireStatus: data,
    });
  } catch (error) {
    dispatch({
      type: ACTIONS.PRODUCTENQ_FAILURE,
      error: error, 
    });
  }
};

export default (
  state = initialState,
  action: {
    [x: string]: unknown;
    type?: string;
  } = {}
) => {
  switch (action.type) {
    case ACTIONS.PRODUCT_REQUEST:
      return { ...state, loading: true, error: null };
    case ACTIONS.PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        products: (action as { products: any }).products,
        error: null,
      };
    case ACTIONS.PRODUCT_FAILURE:
      return { ...state, loading: false, error: action.error };

    case ACTIONS.PRODUCTENQ_REQUEST:
      return { ...state, productEnquireLoading: true, error: null };
    case ACTIONS.PRODUCTENQ_SUCCESS:
      return { ...state, productEnquireLoading: false, productEnquireStatus: action.productEnquireStatus, error: null };
    case ACTIONS.PRODUCTENQ_FAILURE:
      return { ...state, productEnquireLoading: false, error: action.error };
    default:
      return state;
  }
};